import MenuList from "../../Components/MenuList";
import { MassageCategories } from "./conts";

const MasagePage = () => {
  return <MenuList categories={MassageCategories} />;
};

export default MasagePage;
